import { z } from 'zod';
import { accountSchema } from '../../entities/accountTypes';
export const getAccountOrgMembershipRequestParamsSchema = z.object({
    accountId: z.string().uuid(),
    filterData: z.object({
        search: z.string().optional(),
        role: z.string().optional(),
        status: z.string().optional(),
    }),
    sortColumnKey: z.string(),
    offset: z.number(),
    limit: z.number(),
});
const accountOrgMembershipItemSchema = z.object({
    id: z.string(),
    hasLogo: z.boolean().optional(),
    name: z.string(),
    role: z.string().optional(),
    status: z.string().optional(),
});
export const getAccountOrgMembershipResponseSchema = z.object({
    items: z.array(accountOrgMembershipItemSchema),
    total: z.number(),
    filteredCount: z.number(),
    orgRole: accountSchema.shape.orgRole,
    orgStatus: accountSchema.shape.orgStatus,
    memberFullName: z.string(),
});
